export default __webpack_public_path__ + "static/media/pageNotFound.3aa13b14.svg";